/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LngUserList } from '../../models/lng-user-list';
import { LngUserSearchBody } from '../../models/lng-user-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchUsersLng$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * LAST_NAME : the last name
 *   * FIRST_NAME : the first name
 *   * EMAIL : the email
 *   * SPECIFIC_TYPE : corresponds to LNG role
 */
  sortFieldName?: 'DATE' | 'LAST_NAME' | 'FIRST_NAME' | 'EMAIL' | 'SPECIFIC_TYPE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search users for LNG
     */
    body?: LngUserSearchBody
}

export function searchUsersLng$Json(http: HttpClient, rootUrl: string, params?: SearchUsersLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngUserList>> {
  const rb = new RequestBuilder(rootUrl, searchUsersLng$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LngUserList>;
    })
  );
}

searchUsersLng$Json.PATH = '/custom/lng/users/search';
